/* eslint-disable */
import axios from "axios";
import decryptData from "@/store/auth/decryptData";

export default {
  namespaced: true,
  state: () => ({
    reportsList: [],
    reportsListLoaded: false
  }),
  mutations: {
    SET_REPOSRT(state, roles) {
      state.reportsList = roles;
      state.reportsListLoaded = true;
    }
  },
  actions: {
    async fetchReportsList({ commit, state }) {
      if (!state.reportsListLoaded) {
        const res = await axios.get("report");
        const data = decryptData(res.data.payload).data.reports;
        const formatted = data.map(item => ({
          name: item.name,
          file: null,
          link: null
        }));
        commit("SET_REPOSRT", [...formatted]);
      }
    }
  },
  getters: {
    reportsList: state => state.reportsList,
    reportsListLoaded: state => state.reportsListLoaded
  }
};
